<po-page-default [p-title]="literals?.str0002.toLocaleUpperCase()" [p-actions]="actions">
  <tgc-purchase-requests-list>
  </tgc-purchase-requests-list>
</po-page-default>
